/**
 * Boolean operation types for polygon clipping
 */
export enum BooleanOperationType {
  INTERSECTION = 0,
  UNION = 1,
  DIFFERENCE = 2,
  XOR = 3,
}